"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useTranslate } from "../hooks/useTranslate";
const steps = () => __async(null, null, function* () {
  return yield useTranslate(
    [
      {
        element: document.querySelector(".home__menu-element:nth-child(1) a"),
        title: "decidim.app_tour.home_page.nav_processes.title",
        intro: "decidim.app_tour.home_page.nav_processes.intro"
      },
      {
        element: document.querySelector("#how_to_participate"),
        title: "decidim.app_tour.home_page.how_to_participate.title",
        intro: "decidim.app_tour.home_page.how_to_participate.intro"
      },
      {
        element: document.querySelector("#how_to_participate"),
        title: "decidim.app_tour.home_page.how_to_participate.title",
        intro: "decidim.app_tour.home_page.how_to_participate.intro"
      },
      {
        element: document.querySelector("#homepage-upcoming-meetings"),
        title: "decidim.app_tour.home_page.meetings.title",
        intro: "decidim.app_tour.home_page.meetings.intro"
      },
      {
        element: document.querySelector("#statistics"),
        title: "decidim.app_tour.home_page.statistics.title",
        intro: "decidim.app_tour.home_page.statistics.intro"
      },
      {
        element: document.querySelector("#html-block-html:nth-child(1)"),
        title: "decidim.app_tour.home_page.who_are_we.title",
        intro: "decidim.app_tour.home_page.who_are_we.intro"
      }
    ],
    ["title", "intro"]
  );
});
export { steps };
